module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "copy"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('span', [_vm._v("抄送我")]), _vm._v(" "), (_vm.openWxMsgRemid == "Y") ? _c('div', {
    on: {
      "click": _vm.changeStatu
    }
  }, [_vm._v("关闭提醒")]) : _vm._e(), _vm._v(" "), (_vm.openWxMsgRemid == "N") ? _c('div', {
    staticClass: "div",
    on: {
      "click": _vm.changeStatu
    }
  }, [_vm._v("开启提醒")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "check"
  }, [_c('van-checkbox', {
    attrs: {
      "checked-color": "#ee0a24",
      "shape": "square",
      "icon-size": ".15rem",
      "label-disabled": ""
    },
    on: {
      "change": function($event) {
        _vm.pageNo = 1;
        _vm.getCopytList()
      }
    },
    model: {
      value: (_vm.checked),
      callback: function($$v) {
        _vm.checked = $$v
      },
      expression: "checked"
    }
  }, [_vm._v("仅未读/未批阅")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.load),
      expression: "load"
    }],
    staticClass: "tips",
    attrs: {
      "infinite-scroll-distance": "20",
      "infinite-scroll-delay": "500"
    }
  }, _vm._l((_vm.copytList), function(item) {
    return _c('div', {
      staticClass: "item item-first",
      on: {
        "click": function($event) {
          return _vm.$root.gotoDetail(item)
        }
      }
    }, [_c('div', {
      staticClass: "user-submit"
    }, [_vm._v(_vm._s(item.initiatorName) + "提交的" + _vm._s(item.itemName)), (item.isAwait == "Y") ? _c('span') : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "project-name"
    }, [_vm._v(_vm._s(item.bizItemName))]), _vm._v(" "), _c('div', {
      staticClass: "submit-time"
    }, [(item.processProgress == "AUDIT_WAIT") ? _c('span', {
      staticClass: "status"
    }, [_vm._v("审批中")]) : _vm._e(), _vm._v(" "), (item.processProgress == "AUDIT_OK") ? _c('span', {
      staticClass: "status agree"
    }, [_vm._v("审批通过")]) : _vm._e(), _vm._v(" "), (item.processProgress == "AUDIT_REJECTED") ? _c('span', {
      staticClass: "status disagree"
    }, [_vm._v("审批不通过")]) : _vm._e(), _vm._v(" "), (!item.processProgress) ? _c('span', {
      staticClass: "status disagree"
    }) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "time"
    }, [_vm._v(_vm._s(item.initiateTime))])])])
  }), 0), _vm._v(" "), _c('Nav', {
    ref: "nav",
    attrs: {
      "navIndex": 1
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b570a3ee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/app/copy.vue
// module id = 1684
// module chunks = 471